
// ============================================
// ContactScene - GMapなど
// ============================================
GNS.ContactScene = function (a) {
    var b = a.create(a.AbstractScene);
    b.init = function (c) {
        b._super.init.apply(this, [c]), this.mapContainer = new a.DisplayObject("contact__info__container")
    };
    var c, d;
    return b.load = function () {
        a.GMapJSLoader.load(this._loadComplete, this._loadError)
    }, b._bind._loadError = function (a) {
        this.mapContainer.element.style.display = "none", b._super.load.call(this)
    }, b._bind._loadComplete = function (a) {
        if (c) this.mapContainer.element.appendChild(d);
        else {
            d = document.createElement("div"), this.mapContainer.element.appendChild(d);
            var e = [{
                stylers: [{
                    saturation: -100
                }, {
                    lightness: -15
                }, {
                    gamma: .51
                }, {
                    weight: .1
                }]
            }],
                f = new google.maps.LatLng(35.667362, 139.760123),
                g = {
                    zoom: 18,
                    center: f,
                    scrollwheel: !1,
                    draggable: !1,
                    disableDoubleClickZoom: !1,
                    disableDefaultUI: !0,
                    styles: e
                };
            c = new google.maps.Map(d, g);
            var h = new google.maps.Marker({
                position: f,
                title: "dof inc.",
                icon: {
                    url: "/cms/wp-content/themes/dof/assets/release/images/contact/marker.png",
                    anchor: new google.maps.Point(33, 33)
                }
            });
            h.setMap(c)
        }
        b._super.load.call(this)
    }, b.showHandler = function (a) { }, b.hideHandler = function (a) { }, b.resetHandler = function (a) {
        c && this.mapContainer.element.removeChild(d)
    }, b._self
}(GNS);
